import {Component, Input} from '@angular/core';
import { ContentPosition } from 'src/app/model/ui-view.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  // variable declaration
  @Input() logoURL!: string;
  @Input() logoPosition!: ContentPosition;

  constructor(  ) {  }


}
